import { connect } from 'react-redux';
import PageList from 'pages';

export default connect((state) => ({ page: state.location.type }))(PageList);
